import classNames from "classnames";
import React from "react";
import { L10n, L10nId } from "@fidget/common/i18n";
import styles from "../EditableDeleteForm/editableDeleteForm.css";

interface Props {
  textId: L10nId;
}
export const DeleteConfirmation = ({ textId }: Props) => (
  <div className={classNames(styles.container, styles["container-delete-confirmation"])}>
    <div className={styles.content}>
      <div className={classNames(styles.form, styles["form-delete-confirmation"])}>
        <div className={styles["confirm-description"]}>
          <L10n id={textId} />
        </div>
      </div>
    </div>
  </div>
);
